import React, { Fragment, useContext } from "react";

import { Grid } from "@mui/material";

import EnergyFlow from "./flow/EnergyFlow";
import WallboxCard from "./wallbox/WallboxCard";
import HeatpumpCard from "./heatpump/HeatpumpCard";
import useWallboxData from "../../shared/hooks/flow/useWallboxData";
import useHeatpumpData from "../../shared/hooks/flow/useHeatpumpData";
import useFlowData from "../../shared/hooks/flow/useFlowData";
import CustomerLocationClient from "../../shared/api/CustomerLocationClient";
import { AuthContext } from "../../shared/contexts/AuthContext";
import { MessagingContext } from "../MessagingContext";

export default function Flow() {
  const { showMessage } = useContext(MessagingContext);

  const { apiClient } = useContext(AuthContext);

  const locationClient = new CustomerLocationClient(apiClient);

  const { flowData } = useFlowData(locationClient, 5000);

  const {
    wallboxes,
    handleWallboxLockChange,
    handleWallboxSurplusChange,
    handleWallboxHybridChange,
    handleWallboxLockTimeAdding,
    handleWallboxLockTimeDeletion,
    handleWallboxNameChange,
  } = useWallboxData(locationClient, showMessage);

  const hasBattery = flowData?.state?.battery_soc !== undefined;

  const {
    heatpumps,
    handleHeatpumpNameChange,
    handleHeatpumpSgReadySocChange,
    handleHeatpumpSgReadyTimeChange,
    // handleHeatpumpSgReadyChange,
  } = useHeatpumpData(hasBattery, locationClient, showMessage);

  return (
    <Fragment>
      <Grid container justify="center" spacing={3}>
        {flowData && (
          <Grid
            xs={12}
            sm={12}
            md={12}
            item
            display={"flex"}
            justifyContent="center"
            alignItems="center"
          >
            <EnergyFlow
              flowheight={{ xs: "400px", md: "600px" }}
              flowData={flowData}
            />
          </Grid>
        )}
        <Grid
          xs={12}
          sm={12}
          md={12}
          item
          display={"flex"}
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={3}
          >
            {(heatpumps || []).map((heatpump) => (
              <Grid
                xs={12}
                sm={12}
                md={4}
                lg={4}
                item
                justifyContent="center"
                alignItems="center"
                key={`heatpump-card-wrapper-${heatpump.id}`}
              >
                <HeatpumpCard
                  heatpump={heatpump}
                  editName={
                    handleHeatpumpNameChange &&
                    ((name) => handleHeatpumpNameChange(heatpump, name))
                  }
                  setSgReadySoc={
                    handleHeatpumpSgReadySocChange &&
                    ((soc) => handleHeatpumpSgReadySocChange(heatpump, soc))
                  }
                  setSgReadyTime={(lower, higher) =>
                    handleHeatpumpSgReadyTimeChange(heatpump, lower, higher)
                  }
                />
              </Grid>
            ))}
            {(wallboxes || []).map((wallbox) => (
              <Grid
                xs={12}
                sm={12}
                md={4}
                lg={4}
                item
                justifyContent="center"
                alignItems="center"
                key={`wallbox-card-wrapper-${wallbox.id}`}
              >
                <WallboxCard
                  wallbox={wallbox}
                  editName={
                    handleWallboxNameChange &&
                    ((name) => handleWallboxNameChange(wallbox, name))
                  }
                  setLocked={(locked) =>
                    handleWallboxLockChange(wallbox, locked)
                  }
                  setSurplusCharging={(surplusCharging) =>
                    handleWallboxSurplusChange(wallbox, surplusCharging)
                  }
                  setHybridCharging={(hybridChargingCurrent) =>
                    handleWallboxHybridChange(wallbox, hybridChargingCurrent)
                  }
                  addLockTime={(locked, datetime) =>
                    handleWallboxLockTimeAdding(wallbox, locked, datetime)
                  }
                  deleteLockTime={(lockTime) =>
                    handleWallboxLockTimeDeletion(wallbox, lockTime)
                  }
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
}

Flow.propTypes = {};
